import { create } from "zustand";
import type { UserSummary } from "../api/models";
import { emptyUser, normalizeUser } from "../api/user";

interface SessionState {
  user: UserSummary;
  isPreview: boolean;
  setSession: (user: UserSummary, token?: string) => void;
  logout: () => void;
}

const storedUser = (() => {
  try {
    const value = localStorage.getItem("GOP ALA-USER");
    return value
      ? normalizeUser(JSON.parse(value) as Record<string, unknown>)
      : emptyUser;
  } catch {
    return emptyUser;
  }
})();

export const useSession = create<SessionState>((set) => ({
  user: storedUser,
  isPreview: !localStorage.getItem("AUTH-TOKEN"),
  setSession: (user, token) => {
    if (token) localStorage.setItem("AUTH-TOKEN", token);
    localStorage.setItem("GOP ALA-USER", JSON.stringify(user));
    set({ user, isPreview: false });
  },
  logout: () => {
    localStorage.removeItem("AUTH-TOKEN");
    localStorage.removeItem("GOP ALA-USER");
    set({ user: emptyUser, isPreview: true });
  },
}));
